import { useRouteError } from 'react-router';
import { useEffect, useMemo } from 'react';

import RouteErrorPageContent from './RouteErrorPageContent';
import { getIsChunkError, handleRefresh } from './helpers';

/**
 * RouteErrorPage component handles displaying error information for route errors.
 * It also handles chunk load errors by attempting to refresh the page.
 * @returns ReactNode
 */
export default function RouteErrorPage() {
  const error = useRouteError();

  const isChunkError = useMemo(() => {
    return error instanceof Error ? getIsChunkError(error) : false;
  }, [error]);

  useEffect(() => {
    if (!isChunkError) return;

    handleRefresh();
  }, [isChunkError]);

  return <RouteErrorPageContent error={error} isChunkError={isChunkError} />;
}
